/**
 * Content Toggle Container.
 * For switching experience between personal, business and others
 *
 * toggle labelArray data struture
 *  [{
 *    key,
 *    label,
 *    priority,
 *    href,
 *  }, ...]
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _find from 'lodash/find';
import _set from 'lodash/set';
import _result from 'lodash/result';
import classNames from 'classnames';

// Component
import Tabs from '../../contactUs/components/common/Tabs';

// Lib Helper
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';

// Action
import { switchContentToggle } from '../../contactUs/actions/action-content-toggle';

// Content toggle Constants Data
import labels from '../constants/contentToggleData';

// Data Set
const cobrand = Page.getCountry();
const selectedExp = Page.getUserExperience();
const currentPath = Page.getPathName();
const isMobileLayout = Page.isMobileLayout();

// User Checker
const isLoggedIn = Page.isLoggedIn();
const isBusinessUser = Page.getIsBusinessUser();

let inputData = [];

class ContentToggle extends Component {
  // To Solve the three tabs in the toggle overcross issue
  static getContentContainerClass({ inputArray }) {
    return classNames({
      'content-toggle-container': true,
      'content-adapter': Array.isArray(inputArray) && inputArray.length >= 3,
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedExp: this.getExperienceFromHash() || selectedExp,
    };

    this.selectedToggle = this.selectedToggle.bind(this);
    this.changeHandlerNav = this.changeHandlerNav.bind(this);
  }

  getExperienceFromHash() {
    const hashPath = Page.getHashPath();
    if (this.props.hashAnchor && !isLoggedIn && (hashPath === 'personal' || hashPath === 'business')) {
      return hashPath; // Should return 'personal' or 'business' only for article toggle
    }
    return null;
  }

  // Update the Href link for toggle selection
  assignHref(toggleData) {
    toggleData.forEach((input) => {
      _set(input, 'href', this.pathNameWithExp(input.key));
    });
  }

  // Update the Label based on desktop and mobile
  assignLabel(toggleData) {
    const labelSet = isMobileLayout ? this.props.labels.mobile : this.props.labels.desktop;
    toggleData.forEach((input) => {
      _set(input, 'label', labelSet[input.key]);
    });
  }

  // Create input content toggle data
  createLabelArray() {
    return this.userTypeFilter().map((exp, index) => ({
      key: exp,
      priority: index,
    }));
  }

  // Handle Tab onClick event
  changeHandlerNav(tab) {
    // Get the Experience by clicked index
    const selectExp = tab && tab.key;
    this.trackFPTILink(selectExp);
    this.setState({
      selectedExp: selectExp,
    });
  }

  // Filter the content in the toggle
  userTypeFilter() {
    if (!isLoggedIn) {
      return this.props.userExpClass;
    }
    return isBusinessUser
      ? this.props.userExpClass.filter((exp) => exp !== 'personal')
      : this.props.userExpClass.filter((exp) => exp !== 'business');
  }

  // Track FPTI with URL
  trackFPTILink(selectExp) {
    // TODO: Update the id/Page info for tracking
    trackLink({ id: this.props.FPTIPageName, link: `${this.props.FPTILink}|${selectExp}` });
  }

  // get Path with User experience
  pathNameWithExp(key) {
    let changedExp = '';

    const { pathname, search } = this.props;

    const propsPathName = `/${cobrand}/smarthelp${pathname}`;
    const windowPathName = `${currentPath}${search}`;
    const pathNameSelector = propsPathName !== windowPathName ? propsPathName : windowPathName;
    const pathName = Page.getSelectedExpURL({ path: pathNameSelector, experience: key });

    this.props.userExpClass.forEach((exp) => {
      const index = pathName.indexOf(exp);
      if (index >= 0 && exp !== key) {
        changedExp = exp;
      }
    });
    return changedExp ? pathName.replace(changedExp, key) : pathName;
  }

  // Selected toggle for changing active class
  selectedToggle(toggleData) {
    // Update the global state: contentToggle -> exp
    this.props.switchContentToggle(this.state.selectedExp);
    return _result(
      _find(toggleData, (input) => input.key === this.state.selectedExp),
      'priority',
    );
  }

  // Render Tabs as the content toggle
  renderTabsComponent(input) {
    return (
      <Tabs
        labelArray={input}
        selected={this.selectedToggle(input)}
        onClick={this.changeHandlerNav}
        hashAnchor={this.props.hashAnchor}
      />
    );
  }

  render() {
    if (!this.props.display) {
      return null;
    }
    inputData = this.createLabelArray();
    this.assignLabel(inputData);
    this.assignHref(inputData);
    return Array.isArray(inputData) && inputData.length > 1 ? (
      <div className={ContentToggle.getContentContainerClass({ inputArray: inputData })}>
        {this.renderTabsComponent(inputData)}
      </div>
    ) : null;
  }
}

// ContentToggle Props Types
ContentToggle.propTypes = {
  search: PropTypes.string,
  switchContentToggle: PropTypes.func.isRequired,
  pathname: PropTypes.string,
  userExpClass: PropTypes.arrayOf(PropTypes.string),
  labels: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  FPTIPageName: PropTypes.string,
  FPTILink: PropTypes.string,
  display: PropTypes.bool,
  hashAnchor: PropTypes.bool,
};

// ContentToggle Props default values
ContentToggle.defaultProps = {
  search: '',
  pathname: '',
  userExpClass: ['personal', 'business'],
  labels,
  FPTIPageName: 'homePage',
  FPTILink: 'smarthelp-content-toggle-url|tab-toggle',
  display: true,
  hashAnchor: false,
};

// Get the Store data and Pass it as Props.
function mapStateToProps(state) {
  return {
    search: state.location.search,
    pathname: state.location.pathname,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ switchContentToggle }, dispatch);
}

// export default ContentToggle;
export default connect(mapStateToProps, mapDispatchToProps)(ContentToggle);
